import { limitFill } from "@cloudinary/url-gen/actions/resize";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";
import { Link, Text } from "@ttc3k/trekker";
import { BookerByIdQuery, Contact } from "gql/generated";
import { CloudinaryImage } from "shared/components/atoms/CloudinaryImage";
import { getAddressString } from "shared/utils";
import { css } from "styled-system/css";
import { Flex } from "styled-system/jsx";

type ReservationHeaderProps = {
  booker: BookerByIdQuery["bookerById"] | undefined;
  contactInfo: Contact | undefined;
};

export const ReservationHeader = ({
  booker,
  contactInfo,
}: ReservationHeaderProps) => {
  return (
    <Flex
      flexDir={{ base: "column", md: "row" }}
      alignItems={{ base: "flex-start", md: "center" }}
      justifyContent="space-between"
      gap="200"
      w="full"
    >
      {booker?.brandingLogo ? (
        <CloudinaryImage
          image={booker.brandingLogo}
          imageStyleProps={{
            className: css({
              width: "auto",
              maxWidth: "100%",
              height: "80px",
              objectFit: "contain",
              aspectRatio: "unset",
              flexShrink: 0,
            }),
          }}
          alt={booker.name.en ?? ""}
          resize={limitFill().height(80).gravity(autoGravity())}
        />
      ) : (
        <Text visual="bodySemiBold">{booker?.name.en ?? ""}</Text>
      )}

      <Flex
        flexDir="column"
        gap="0"
        minW={0}
        w={{ base: "full", md: "auto" }}
        alignItems={{ base: "flex-start", md: "flex-end" }}
        textAlign={{ base: "left", md: "right" }}
      >
        <Text visual="smallMedium">
          {getAddressString(contactInfo?.address ?? {}, false, false)}
        </Text>
        <Flex
          alignItems="center"
          justifyContent={{ base: "flex-start", md: "flex-end" }}
          gap="50"
          flexWrap="wrap"
        >
          {contactInfo?.email && (
            <Link
              href={`mailto:${contactInfo.email}`}
              color="text.light"
              size="sm"
            >
              {contactInfo.email}
            </Link>
          )}
          {contactInfo?.email && contactInfo?.phone && (
            <Text visual="smallMedium" color="text.light">
              •
            </Text>
          )}
          {contactInfo?.phone && (
            <Link
              href={`tel:${contactInfo.phone}`}
              color="text.light"
              size="sm"
            >
              {contactInfo.phone}
            </Link>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
